/* eslint-disable import/prefer-default-export */

// from https://www.w3schools.com/js/js_cookies.asp
export const getHubspotCookie = () => {
  const name = 'hubspotutk=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const submitForm = async (formGuid, fields, cb, timeout) => {
  const context = {
    pageUri: window.location.href,
    pageName: document.title,
  };
  const hutk = getHubspotCookie();
  if (hutk) {
    context.hutk = hutk;
  }

  let timeoutID;
  if (cb) {
    timeoutID = setTimeout(cb, timeout || 5000);
  }
  await fetch(`https://api.hsforms.com/submissions/v3/integration/submit/7242039/${formGuid}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    body: JSON.stringify({ fields, context }),
  });
  if (timeoutID) {
    clearTimeout(timeoutID);
    cb();
  }
};
